<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">维纳宝发券营销对接说明</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p v-for="(nl,index) in navList" :key="index" :class=" anchorId == index ? 'nowAnchor' : '' " @click="changeanchorId(index, nl.id)">
          {{nl.text}}
        </p>
      </div>
    </div>
    <section class="mainFun" id="mainFun">
      <div class="mainDivWidth flexDiv feaTure">
        <div class="introduceTextImg">
          <img
            src="static/img/docdescription/mainpic.png"
            class="introduceImg"
          />
          <p>维纳宝发券营销<br>对接说明</p>
        </div>
        <div class="first-introduceText">
          <div class="introduceText-Title flexDiv">
            <p class="titleBg">主要功能</p>
            <p class="subheading">MAJOR FUNCTION</p>
          </div>
          <div class="cer-FunCon">
            <p>
              维纳宝是一款帮助各行业简单快捷的进行线上运营和数据分析的手机应用软件。由陕西维纳数字科技股份有限公司推出。现阶段主要服务于金融业、服务业等维纳股份合作企业。
              用户在享受简单快捷的线上运营方式的同时，还可获得维纳全平台的数据信息，帮助自己了解行业动态，调整战略方向及完善自身不足。
              维纳宝，一秒成为资深首席运营官。
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="joinFlow" class="payforCont">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">接入流程</h3>
          <div class="joinCont flexDiv">
            <div class="joinflow"  v-for="(joflow, index) in joinflowList" :key="index">
              <img :src="joflow.joflow" alt="">
              <p v-text="joflow.jointxt"></p>
            </div>
          </div>
        </div>
      </section>
    <section id="sellingPoint">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">接入优势</h3>
        <div class="advantage flexDiv">
          <div class="advantCont" v-for="(spl, index) in sellingPointList" :key="index">
            <img :src="spl.pic" alt="">
            <p v-text="spl.title"></p>
          </div> 
        </div>
      </div>
    </section>
    <section class="modelFun" id="modelFun">
      <h3 class="sectionTitle">功能模块</h3>
      <div class="flexDiv mainDivWidth modelFuncont">
        <div class="modelmain"  v-for="(mod, index) in modelfunList" :key="index">
          <img :src="mod.pics" alt="">
          <p v-text="mod.title"></p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'dockWnbsendC',
  data:function(){
    return {
      anchorId: 0,
      navList: [
        {text: '主要功能', id: 'mainFun'},
        {text: '接入流程', id: 'joinFlow'},
        {text: '接入优势', id: 'sellingPoint'},
        {text: '功能模块', id: 'modelFun'}
      ],
      sellingPointList:[
        {title: '快速发券', pic:"static/img/docdescription/icontont/iconfont01.png"},
        {title: '简单快捷的线上运营', pic:"static/img/docdescription/icontont/iconfont02.png"},
        {title: '平台数据快速了解', pic:"static/img/docdescription/icontont/iconfont03.png"},
        {title: '行业动态一键洞悉',pic:"static/img/docdescription/icontont/iconfont04.png"},
      ],
      modelfunList:[
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon01.png",
          title:"注册登录"
        },
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon02.png",
          title:"首页"
        },
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon03.png",
          title:"个人中心"
        },
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon04.png",
          title:"电子券核销"
        },
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon05.png",
          title:"交易数据"
        },
        {
          pics:"static/img/docdescription/modelfun/modelicon/icon06.png",
          title:"优惠券发放"
        }
      ],
      joinflowList:[
        {
          joflow:"static/img/docdescription/SDKpic/conneticon/joinicon01.png",
          jointxt:"注册成为佰付美营销平台合作会员"
        },
        {
          joflow:"static/img/docdescription/SDKpic/conneticon/joinicon02.png",
          jointxt:"下载维纳宝应用程序/获取维纳宝电脑登录地址"
        },
        {
          joflow:"static/img/docdescription/SDKpic/conneticon/joinicon03.png",
          jointxt:"申请开通使用权限"
        },
        {
          joflow:"static/img/docdescription/SDKpic/conneticon/joinicon04.png",
          jointxt:"开通权限"
        },
        {
          joflow:"static/img/docdescription/SDKpic/conneticon/joinicon05.png",
          jointxt:"线上发券"
        }
      ]
    }
  },
  mounted() {
  },
  methods:{
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id){
      this.anchorId = num;
      $('html, body').animate({scrollTop: $('#'+id).offset().top }, 1000);
      return false;// 返回false可以避免在原链接后加上#
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/descriptionClass/docStyle";
  @import "../../assets/css/descriptionClass/modelFun";
</style>



// WEBPACK FOOTER //
// src/pages/dockingConPage/document3-sendCoupon.vue